<template>
  <div class="product-center">
    <Form
        ref="editForm"
        :model="form"
        :rules="diyData.rules"
        :label-width="100"
    >

      <Row>
        <div class="product-title">基础信息</div>
        <Col span="24">
          <FormItem label="商品名称：" prop="title">
            <label>{{form.title}}</label>
          </FormItem>
        </Col>

        <FormItem label="商品售价：" prop="price">
          <label>{{form.price}}</label>
        </FormItem>

        <FormItem label="面积计费：" prop="areaBilling">
          <label>{{form.areaBilling==1?'是':'否'}}</label>
        </FormItem>

<!--        <template v-if="form.skuEnabel==1">-->
<!--          <div class="skuEnabel" v-for="(item,index) in diyData.specList" :key="index">-->
<!--            <div class="skuEnabel-tit">规格{{ index + 1 }}:</div>-->
<!--            <div class="skuEnabel-right">-->
<!--              <div class="skuEnabel-right-header">-->
<!--                <div>-->
<!--                  <Input placeholder="请输入" v-model="item.name" style="width:160px;margin-right:20px"/>-->
<!--                  <span style="margin-right: 10px">定制：</span>-->
<!--                  <label>{{item.customEnable==1?'是':'否'}}</label>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="skuEnabel-right-item" v-for="(iterm,idx) in item.items" :key="idx">-->
<!--                <label>{{iterm.name}}</label>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
        <template v-if="form.skuEnabel==1">
          <Divider style="background: #ccc"/>
          <div class="product-title">规格售价</div>
          <Table
              ref="selection"
              :columns="generateColumns()"
              border :span-method="handleSpan"
              :data="diyData.skuList">
          </Table>
        </template>
        <Divider style="background: #ccc"/>
        <div class="product-title">后道工序</div>
        <Col span="24">
          <div class="industrial-manage-center" v-for="(item,index) in form.processList" :key="index">
            <div class="industrial-manage-item">
              <div class="industrial-manage-item-left">
                <div class="industrial-manage-item-select">
                  <label>{{item.title}}</label>
                </div>
                <div class="industrial-manage-item-tit">价格：</div>
                <div class="industrial-manage-item-select">
                  <label>{{item.price}}</label>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Divider style="background: #ccc"/>
        <div class="product-title">基础信息</div>
        <Col span="24">
          <FormItem label="上架状态：" prop="status">
            <label>{{form.status==1?'上架':'下架'}}</label>
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem label="主图：" prop="img">
            <div class="upload-Img">
              <div v-for="(item,index) in form.img" :key="index" class="look-img" style="margin-right:10px">
                <img :src="item" style="width: 100%"/>
                <div class="demo-upload-list-cover">
                  <Icon
                      type="ios-eye-outline"
                      @click.native="lookFile(item)"
                  ></Icon>
                </div>
              </div>
            </div>
          </FormItem>
        </Col>
        <FormItem label="商品原价：" prop="originalPrice">
          <label>{{form.originalPrice}}</label>
        </FormItem>
        <FormItem label="价格单位：" prop="skuName">
          <label>{{form.skuName}}</label>
        </FormItem>
        <template>
          <FormItem label="开启秒杀：" prop="secEnabel">
            <label>{{form.secEnabel==1?'是':'否'}}</label>
          </FormItem>
        </template>

        <FormItem label="商品限购：" prop="limitEnabel">
          <label>{{form.limitEnabel==1?'是':'否'}}</label>
          <template v-if="form.limitEnabel==1">
            <span style="margin-left:20px;font-size:14px">每人限购：{{form.limitNumber}}</span>
          </template>
        </FormItem>
        <Divider style="background: #ccc"/>
        <div class="product-title">更多设置</div>
        <!-- <FormItem label="物流配送：" prop="title">
              <Select clearable
              style="max-width:300px;width:100%"
              v-model="form.typeId"
              placeholder="请选择"
            >
          </Select>
        </FormItem> -->

        <FormItem label="是否标品：" prop="standard">
          <label>{{ form.standard == 1 ? '是' : '否' }}</label>
        </FormItem>
        <FormItem label="是否订制品：" prop="custom">
          <label>{{ form.custom == 1 ? '是' : '否' }}</label>
        </FormItem>
        <FormItem label="是否需要设计：" prop="needDesign">
          <label>{{ form.needDesign == 1 ? '是' : '否' }}</label>
        </FormItem>
        <FormItem label="是否需要制作：" prop="needMake">
          <label>{{ form.needMake == 1 ? '是' : '否' }}</label>
        </FormItem>
        <FormItem label="是否需要安装：" prop="installEnabel">
          <label>{{ form.installEnabel == 1 ? '是' : '否' }}</label>
        </FormItem>
        <FormItem label="支持配送方式：" prop="deliverySupport">
          <label v-if="form.deliverySupport==1">快递</label>
          <label v-if="form.deliverySupport==2">送货上门</label>
          <label v-if="form.deliverySupport==3">都支持</label>
        </FormItem>
        <FormItem label="送达时间：" prop="deliveryTime">
          <label>{{ form.deliveryTime }}</label>
        </FormItem>
      </Row>
      <FormItem>
        <div class="footer" style="position: fixed; right: 20px; top: 50px;width:160px; z-index: 100;">
          <Button @click="ModalCancel">返回</Button>
        </div>
      </FormItem>
    </Form>
    <Modal
        footer-hide
        v-model="previewImgShow"
        @on-cancel="previewImgShow=false">
      <img :src="previewImgUrl" style="width: 100%">
    </Modal>
  </div>
</template>

<script>
import { apiIndustryList } from '@/api/industrial-manage.js'
import { apiProductInfo, apiProductSave } from '@/api/product-manage.js'
import { apiProducttypeAll } from '@/api/classification-manage.js'
import { apiProducttempSearch } from '@/api/template-manage.js'

export default {
  name: 'show-price',
  data () {
    return {
      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      query: {},
      previewImgShow: false,
      previewImgUrl: '',
      currentTemplate: {},
      skuNameEditingOld: '',
      oldRow: '',
      oldColumn: '',
      diyDom: {},
      mergedCells: [], // 用于记录哪些单元格已经被合并过了
      skuTableText: [],
      diyData: {
        // 模板列表
        templateList: [
          //   {
          //     id:'',
          //     img:'',
          //     productId:'',
          //     sort:'',
          //     sourceFile:'',
          //     tag:'',
          //     title:'',
          // }
        ],
        // 商品规格
        specList: [],
        // 多规格列表
        skuList: [
          //   {
          //   code:'',
          //   id:'',
          //   info:'',
          //   price:'',
          //   sort:'',
          //   status:'',
          // }
        ],
        columns: [{
          title: '规格名',
          key: 'info'
        }, {
          title: '价格',
          key: 'price',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: params.row.price
              },
              on: {
                input: event => {
                  this.diyData.skuList[params.index]['price'] = event
                }
              }
            })
          }
        }, {
          title: '产品编号',
          key: 'code',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: params.row.code
              },
              on: {
                input: event => {
                  this.diyData.skuList[params.index]['code'] = event
                }
              }
            })
          }
        }, {
          title: '是否上架',
          key: 'status',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                type: 'primary',
                size: 'small',
                trueValue: '1',
                falseValue: '0',
                value: params.row.status + ''
              },
              on: {
                'on-change': (e) => {
                  this.diyData.skuList[params.index]['status'] = e
                }
              }
            })
          }
        }]

      },
      form: {
        code: '',
        contentUrl: [],
        deliveryTime: '',
        limitEnabel: 0,
        areaBilling: 0,
        icon: '',
        id: '',
        img: [],
        video: '',
        // industryPid: '',
        // industryId: '',
        // installEnabel: '',
        limitNumber: '',

        originalPrice: '',
        price: '',
        showSales: '',
        personViewNum: '',
        skuEnabel: 0,
        skuList: [],
        processList: [
          // {
          //   id:'',
          //   price:'',
          //   productId:'',
          //   sort:'',
          //   title:'',
          // }
        ],
        skuName: '',
        sort: '',
        specList: [],
        status: 0,
        tag: '',
        templateList: [],
        title: '',
        typeId: '',
        secPrice: '',
        secEnabel: 0,
        standard: 0,
        custom: 0,
        deliverySupport: 0,
        needDesign: 0,
        needMake: 0
      },
      apiData: {
        industryList: [],
        childIndustryList: [],
        producttypeList: [],
        allTemplateList: [],
        tempIndex: 0
      },
      filterQuery: ''
    }
  },
  computed: {
    filteredData () {
      if (!this.filterQuery) return this.apiData.filterQuery

      const lowerQuery = this.apiData.filterQuery.toLowerCase()
      return this.apiData.filterQuery.filter(item =>
        item.title.toLowerCase().includes(lowerQuery) ||
          item.tag.toLowerCase().includes(lowerQuery) ||
          item.code.toLowerCase().includes(lowerQuery)
      )
    }
  },
  methods: {
    getData () {
      var that = this
      var data = []

      this.diyData.specList.forEach((item, index) => {
        data.push(item.items)
      })

      var skuLData = []
      data.forEach((citem, cindex) => {
        var list = []
        citem.forEach((items, idx) => {
          if (skuLData.length > 0) {
            skuLData.forEach((itemD, ix) => {
              if (items.name && itemD) {
                // 改为二维数组：[前一项, 当前项]
                list.push([...itemD, items.name]) // 合并之前的数组和当前项
              }
            })
          } else {
            if (items.name) {
              // 第一次直接推入一维数组
              list.push([items.name])
            }
          }
        })
        skuLData = list
      })
      this.skuTableText = skuLData
    },
    // 获取模板列表
    generateColumns () {
      this.getData()

      const pecColumns = this.diyData.specList.map((item, columnIndex) => ({
        title: item.name,
        key: `pec_${item.id}`,
        render: (h, params) => {
          // const text = params.row.info.split(' ')[columnIndex] || ''
          const text = this.skuTableText[params.index][columnIndex]
          return h('div', {
            style: {
              padding: '6px 12px',
              fontSize: '14px'
            },
            domProps: {
              innerHTML: text
            },
            attrs: {
              title: text // 添加 title 属性用于提示
            }
          })
        }
      }))

      // 合并原有列 + pecList 列
      return [...pecColumns, ...[
        // {
        //   title: '规格名',
        //   key: 'info'
        // },
        {
          title: '价格',
          key: 'price'
        },
        {
          title: '图片',
          key: 'img',
          render: (h, params) => {
            const imgUrl = params.row.img

            // 图片不存在时显示上传按钮
            if (!imgUrl) {
              return h('div', {
                domProps: {
                  innerHTML: ""
                },
              })
            }

            // 图片存在时显示图片 + 删除按钮
            return h('div', { style: { display: 'flex', alignItems: 'center' } }, [
              h('img', {
                attrs: {
                  src: imgUrl,
                  alt: '商品图片'
                },
                style: {
                  width: '40px',
                  height: '40px',
                  cursor: 'pointer',
                  objectFit: 'cover'
                },
                on: {
                  click: () => {
                    this.lookFile(imgUrl)
                  }
                }
              })
            ])
          }
        },
        {
          title: '产品编号',
          key: 'code'
        },
        {
          title: '是否上架',
          key: 'status',
          render: (h, params) => {
            var text = params.row.status == 1 ? '上架' : '下架'
            return h('div', {
              style: {
                padding: '6px 12px',
                fontSize: '14px'
              },
              domProps: {
                innerHTML: text
              },
              attrs: {
                title: text // 添加 title 属性用于提示
              }
            })
          }
        }
      ]]
    },
    // 合并单元格方法
    handleSpan ({ row, column, rowIndex, columnIndex }) {
      // 只对第一个动态规格列（info字段）做合并
      if (columnIndex < this.diyData.specList.length) {
        const currentVal = this.skuTableText[rowIndex][columnIndex]

        // 跳过已经合并过的单元格
        if (this.mergedCells[rowIndex] && this.mergedCells[rowIndex][columnIndex]) {
          return { rowspan: 0, colspan: 0 } // 不渲染该单元格
        }

        // 获取下一行对应的值
        if (rowIndex + 1 < this.diyData.skuList.length) {
          const nextVal = this.skuTableText[rowIndex + 1][columnIndex]

          if (currentVal !== nextVal) {
            return [1, 1]
          } else {
            // 计算从当前行开始连续相同的行数
            let count = 1
            for (let i = rowIndex + 1; i < this.diyData.skuList.length; i++) {
              const nextVal = this.skuTableText[i][columnIndex]
              if (nextVal === currentVal) {
                count++
              } else {
                break
              }
            }

            // 对后续被合并的行也打上标记，防止重复处理
            for (let i = rowIndex + 1; i < rowIndex + count; i++) {
              if (!this.mergedCells[i]) {
                this.mergedCells[i] = []
              }
              this.mergedCells[i][columnIndex] = true
            }
            return {
              rowspan: count,
              colspan: 1
            }
          }
        } else {
          // 最后一行，无法合并
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }

      // 其他列不处理
      return {
        rowspan: 1,
        colspan: 1
      }
    },
    deleteSkuImage (index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要删除这张图片吗？',
        onOk: () => {
          // 清除对应索引的图片字段
          this.diyData.skuList[index].img = ''
          this.$Message.success('图片删除成功')
        }
      })
    },
    setFilterQuery (query) {
      this.filterQuery = query
    },
    getProducttempSearch () {
      apiProducttempSearch().then(res => {
        this.apiData.allTemplateList = res.data.map(res => {
          res.icon = res.icon + '?x-oss-process=image/resize,m_fill,w_30,h_30'
          // res.img = res.img + "?x-oss-process=image/resize,m_fill,w_30,h_30"
          res.name = res.code + res.title + res.tag
          return res
        })
        this.apiData.tempIndex = this.apiData.allTemplateList[0].id
      })
    },
    getProducttypeAll () {
      apiProducttypeAll().then(res => {
        this.apiData.producttypeList = res.data
      })
    },
    getIndustryInfro () {
      apiIndustryList().then(res => {
        var obj = []
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].level == 1) {
            var data = res.data[i]
            data.children = []
            data.isEdit = false
            obj.push(data)
          } else {
            obj = obj.map(item => {
              if (item.id == res.data[i].parentId) {
                var children = res.data[i]
                children.isEdit = false
                item.children.push(children)
              }
              return item
            })
          }
        }
        this.apiData.industryList = obj
        if (this.form.industryPid) {
          this.getIndustry(this.form.industryPid)
        }
      })
    },
    getIndustry (e) {
      this.apiData.childIndustryList = []
      var childIndustryList = this.apiData.industryList.filter(item => {
        return item.id == e
      })
      if (childIndustryList && childIndustryList.length > 0) {
        this.apiData.childIndustryList = childIndustryList[0].children
      }
    },
    /**
     * 获取产品详情
     */
    getDetail () {
      var that = this
      apiProductInfo({ id: this.query.id }).then(res => {
        this.form = {
          code: res.data.code,
          contentUrl: res.data.contentUrl ? res.data.contentUrl.split(',') : [],
          deliveryTime: res.data.deliveryTime,
          limitEnabel: res.data.limitEnabel + '',
          areaBilling: res.data.areaBilling + '',
          icon: res.data.icon || '',
          id: res.data.id,
          img: res.data.img ? res.data.img.split(',') : [],
          video: res.data.video,
          // industryPid: res.data.industryPid + '',
          // industryId: res.data.industryId + '',
          installEnabel: res.data.installEnabel ? res.data.installEnabel + '' : '0',
          limitNumber: res.data.limitNumber,
          originalPrice: res.data.originalPrice,
          price: res.data.price,
          showSales: res.data.showSales,
          personViewNum: res.data.personViewNum,
          skuEnabel: res.data.skuEnabel + '',
          skuList: res.data.skuList || [],
          skuName: res.data.skuName,
          sort: res.data.sort,
          specList: res.data.specList || [],
          status: res.data.status + '',
          tag: res.data.tag,
          templateList: res.data.templateList || [],
          title: res.data.title,
          typeId: res.data.typeId + '',
          processList: res.data.processList || [],
          secPrice: res.data.secPrice,
          secEnabel: res.data.secEnabel ? res.data.secEnabel + '' : '0',
          standard: res.data.standard ? res.data.standard + '' : '0',
          custom: res.data.custom ? res.data.custom + '' : '0',
          needDesign: res.data.needDesign ? res.data.needDesign + '' : '0',
          deliverySupport: res.data.deliverySupport + '',
          needMake: res.data.needMake ? res.data.needMake + '' : '0'
        }
        if (this.apiData.industryList && this.apiData.industryList.length > 0) {
          this.getIndustry(res.data.industryPid)
        }
        if (res.data.templateList && res.data.templateList.length > 0) {
          this.diyData.templateList = res.data.templateList.map(item => {
            item.icon = item.icon + '?x-oss-process=image/resize,m_fill,w_30,h_30'
            item.img = item.img + '?x-oss-process=image/resize,m_fill,w_30,h_30'
            item.status = item.status + ''
            return item
          })
        }
        if (res.data.specList && res.data.specList.length > 0) {
          this.diyData.specList = res.data.specList.map(item => {
            item.customEnable = item.customEnable + ''
            item.items = item.items.split(',').map(item => {
              return {
                name: item,
                icon: ''
              }
            })
            return item
          })
        }
        if (res.data.skuList && res.data.skuList.length > 0) {
          this.diyData.skuList = res.data.skuList.map(item => {
            item.status = item.status + ''
            return item
          })
        }
      })
    },
    uploadSuccess (type, res, index = 0, idx) {
      if (res.code != 200) {
        return this.$Modal.error({ title: '提示', content: res.msg })
      }
      this.$Message.success('文件上传成功')
      if (type === 'img') {
        this.form.img.push(res.data.fileUrl)
      }
      if (type === 'icon') {
        this.form.icon = res.data.fileUrl
      } else if (type === 'video') {
        this.form.video = res.data.fileUrl
      } else if (type === 'sourceFile') {
        this.diyData.templateList[index].sourceFile = res.data.fileUrl
      } else if (type === 'contentUrl') {
        this.form.contentUrl.push(res.data.fileUrl)
      } else if (type === 'spec') {
        this.diyData.specList[index].items[idx].icon = res.data.fileUrl
        console.log(this.diyData.specList[index].items[idx].name)
      }
    },
    // 文件上传失败
    uploadErr () {
      this.$Spin.hide()
      this.$Modal.error({
        title: '提示',
        content: '文件上传失败，请重试'
      })
    },
    // 查看文件
    lookFile (url) {
      this.previewImgUrl = url
      this.previewImgShow = true
    },
    // 删除文件
    deleteFile (type, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          if (type == 'img') {
            this.form.img.splice(index, 1)
          } else if (type == 'video') {
            this.form.video = ''
          } else if (type == 'icon') {
            this.form.icon = ''
          } else if (type == 'contentUrl') {
            this.form.contentUrl.splice(index, 1)
          }
        }
      })
    },
    // 添加模板
    addtemplateList () {
      if (!this.currentTemplate.id) {
        this.$Message.warning('请选择模板')
        return
      }
      var exists = false
      this.diyData.templateList.forEach(item => {
        if (item.tempId === this.currentTemplate.id) {
          this.$Message.warning('模板已存在')
          exists = true
        }
      })
      if (exists) {
        return
      }
      var obj = {
        id: '',
        sort: '',
        tempId: this.currentTemplate.id,
        title: this.currentTemplate.title,
        img: this.currentTemplate.img
      }
      this.diyData.templateList.push(obj)
    },
    updateCurrentTemplate (selectedId) {
      const selected = this.apiData.allTemplateList.find(item => item.id === selectedId)
      this.currentTemplate = selected || {}
    },
    selecTemplateList (e, index) {
      this.updateCurrentTemplate(e)
      var that = this
      if (e) {
        this.apiData.allTemplateList.forEach(v => {
          if (v.id == e) {
            that.diyData.templateList[index].tempId = v.id
            that.diyData.templateList[index].title = v.title
            that.diyData.templateList[index].img = v.img
          }
        })
      } else {
        that.diyData.templateList[index].tempId = ''
        that.diyData.templateList[index].title = ''
        that.diyData.templateList[index].img = ''
      }
    },
    deletetemplate (index) {
      this.diyData.templateList.splice(index, 1)
    },

    // 取消
    ModalCancel () {
      this.$router.go(-1)
    },
    // 增加后道工序
    addtemProcessList () {
      var obj = {
        id: '',
        price: '',
        productId: '',
        sort: '',
        title: ''
      }
      this.form.processList.push(obj)
    },
    // 删除后道工序
    deleteProcessList (index) {
      this.form.processList.splice(index, 1)
    },
    // 排序
    getSonSort (index, type) {
      var idx1 = 0, idx2 = 0
      if (type == 'up') {
        idx1 = index
        idx2 = index - 1 > 0 ? index - 1 : 0
      } else {
        idx1 = index
        idx2 = index + 1 >= this.form.processList.length ? index : index + 1
      }
      let arr = this.form.processList.map((item, index) => {
        if (!item.sort) {
          item.sort = index
        }
        return item
      }); // 示例数组
      [arr[idx1], arr[idx2]] = [arr[idx2], arr[idx1]]
      this.form.processList = arr
    },
    // 增加规格
    addskuEnabel () {
      var obj = {
        customEnable: '',
        items: [],
        id: '',
        name: '',
        mark: ''
      }
      this.diyData.specList.push(obj)
    },
    addChildSkuEnabel (index) {
      this.diyData.specList[index].items.push({ name: '' })
    },
    deleteSpecList (index) {
      this.diyData.specList.splice(index, 1)
      this.getskuList()
    },
    /**
     * 规格明细排序
     */
    getSort (index, idx, type) {
      let arr = this.diyData.specList[index].items
      // 假设我们要交换索引为1和3的元素
      var index1 = 0, index2 = 0
      if (type == 'up') {
        index2 = idx
        if (idx > 0) {
          index1 = idx - 1
        } else {
          index1 = 0
        }
      } else {
        index1 = idx

        if (arr.length - 1 > idx) {
          index2 = idx + 1
        } else {
          index2 = idx
        }
      }
      // 使用splice方法
      if (index1 != index2) {
        arr.splice(index1, 1, ...arr.splice(index2, 1, arr[index1]))
        this.getskuList()
      }
    },
    deleteChildSpecList (index, idx) {
      this.diyData.specList[index].items.splice(idx, 1)
      this.getskuList()
    },
    /**
     * 输入规格名称变更
     */
    skuItemOnFocus (index, idx) {
      var skuNameEditingOld = this.diyData.specList[index].items[idx].name
      if (this.oldRowIndex != index && this.oldColumn != idx) {
        this.skuNameEditingOld = skuNameEditingOld
      }
      this.oldRowIndex = index
      this.oldColumn = idx
    },
    /**
     * 输入规格名称变更
     */
    skuItemOnBlur (index, idx) {
      const event = window.event || event // 兼容性获取事件对象
      const newValue = event.target.value // 新值
      const oldValue = this.skuNameEditingOld

      if (oldValue && newValue && oldValue !== newValue) {
        this.diyData.skuList.forEach(sku => {
          if (sku.info && sku.info.includes(oldValue)) {
            sku.info = sku.info.replace(oldValue, newValue)
          }
        })
      }
      this.getskuList()
    },
    /**
     * 获取多规格列表
     */
    getskuList () {
      var that = this
      var data = []

      this.diyData.specList.forEach((item, index) => {
        data.push(item.items)
      })
      var listData = [], skuLData = []
      data.forEach((citem, cindex) => {
        var list = []
        citem.forEach((items, idx) => {
          if (skuLData.length > 0) {
            skuLData.forEach((itemD, ix) => {
              if (items.name && itemD) {
                list.push(itemD + ' ' + items.name)
              }
            })
          } else {
            if (items.name) {
              list.push(items.name)
            }
          }
        })
        skuLData = list
      })
      var skuList = this.diyData.skuList
      var skuDataList = skuLData.map(v => {
        var obj = {
          code: '',
          id: '',
          info: v,
          price: '',
          sort: '',
          status: '1'
        }
        skuList.forEach((item, index) => {
          if (item.info == v) {
            obj = item
          }
        })
        return obj
      })
      this.diyData.skuList = skuDataList
    },
    addSpecifications () {
      this.specificationsData.push('')
    },
    getConfirm () {
      var params = { ...this.form }
      params.id = this.query.id
      params.icon = this.form.img[0] || ''
      params.img = this.form.img.join(',')
      params.contentUrl = this.form.contentUrl.join(',')
      params.skuList = this.diyData.skuList.map(item => {
        var obj = {
          code: item.code || '',
          id: item.id || '',
          info: item.info || '',
          price: item.price || '',
          sort: item.sort || '',
          status: item.status || '1',
          img: item.img || ''
        }
        return obj
      })
      params.specList = this.diyData.specList.map(item => {
        var items = item.items.map(v => {
          return v.name
        })

        var obj = {
          customEnable: item.customEnable || '0',
          id: item.id || '',
          name: item.name || '',
          items: items.join(','),
          mark: item.mark || ''
        }
        return obj
      })
      params.templateList = this.diyData.templateList.map((item, index) => {
        var obj = {
          id: item.id || '',
          tempId: item.tempId || '',
          sort: item.sort || index,
          title: item.title || ''
        }
        return obj
      })

      apiProductSave(params).then(res => {
        if (res.code == 200) {
          this.$Message.success('保存成功')
          // this.$router.push({name: 'product-manage'})
        } else {
          this.$Message.error(res.msg)
        }
      })
    }

  },
  mounted () {
    this.query = this.$route.query
    // this.getIndustryInfro()
    this.getProducttypeAll()
    // this.getProducttempSearch()
    if (this.query.id) {
      this.getDetail()
    }
    // 初始化 mergedCells 状态
    this.mergedCells = []
  }
}
</script>

<style scoped lang="less">
.max-w200 {
  max-width: 200px;
  width: 100%;
}

.product-center {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;

  .product-title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 20.27px;
    margin-bottom: 15px;
    color: rgba(56, 56, 56, 1);
  }
}

.addClass {
  width: 80px;
  height: 24px;
  opacity: 1;
  border-radius: 2px;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: inline-block;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px
}

.tag {
  width: 50px;
  height: 26px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(255, 87, 51, 1);
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-left: 10px;
  display: inline-block;
  cursor: pointer;
}

.skuEnabelIcon {
  margin-left: 15px;
  font-size: 24px;
  cursor: pointer;
}

.specifications {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20.27px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  margin-bottom: 10px;
  padding-left: 100px;
}

.pdl10 {
  padding-left: 10px;
}

.templateList {
  width: 100%;
  display: flex;
  padding: 10px 0px;
  align-items: center;

  .upload-Img {
    width: 40px;
    height: 40px;

    .look-img {
      margin-left: 0px;
      width: 40px;
      height: 40px;

      img {
        margin-left: 0px;
      }

      .demo-upload-list-cover {
        line-height: 40px;
      }

      .demo-upload-list-cover i {
        line-height: 40px;
      }
    }

    .upload-Img {
      .demo-upload-list-cover i {
        line-height: normal;
      }
    }

    .upload-btn {
      padding-top: 5px;
      width: 40px;
      height: 40px;
    }
  }
}

.sku-upload-btn {
  width: 30px;
  height: 30px;
}

.add-btn {
  width: 100px;
  padding: 10px 0px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: rgba(42, 130, 228, 1);
}

.contentUrl {
  width: 100%;
  padding: 10px 0px;
}

.skuEnabel {
  width: 100%;
  max-width: 700px;
  box-sizing: border-box;
  background: rgba(229, 229, 229, 0.5);
  padding: 15px;
  margin-bottom: 10px;
  display: flex;

  .skuEnabel-tit {
    width: 80px;
    line-height: 32px;
  }

  .skuEnabel-right {
    width: 100%;

    .skuEnabel-right-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .DeleteAttribute {
        color: #2a82e4;
        cursor: pointer;
      }
    }

    .skuEnabel-right-item {
      display: flex;
      margin-top: 10px;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin-left: 20px;
        display: block;
        cursor: pointer;
      }
    }
  }

}

.industrial-manage-center {
  background: rgba(229, 229, 229, 0.5);
  width: 100%;
  padding: 10px 20px;
  margin-bottom: 10px;

  .industrial-manage-item {
    width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    margin-bottom: 10px;

    .industrial-manage-item-left {
      display: flex;
      align-items: center;

      .industrial-manage-item-select {
        margin-right: 10px;
      }
    }

    .industrial-manage-item-right {
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin-left: 20px;
        display: block;
        cursor: pointer;
      }
    }

  }
}

.TemplateList {
  width: 100%;
  display: flex;
  align-items: center;

}

.look-img {
  display: flex;
  align-items: center;
  border: 1px dashed rgba(197, 197, 197, 1);
  text-align: center;
  justify-content: space-evenly;
  position: relative;
  overflow: hidden;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
}

.look-img:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  line-height: 98px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>
